const __filename = "/app/components/website/review_band/ns.js", __dirname = "/app/components/website/review_band";
import WebComponent from '@rubygems/hue/app/components/web_component'

// The testimonial carousel — live's Bootstrap `data-ride="carousel"`, reproduced without Bootstrap.
// One quote showing, a row of dots under it, and a slide every five seconds, which is that
// plugin's own default interval.
//
// EVERYTHING IS ALREADY IN THE DOCUMENT. The quotes and the dots are server-rendered (see ns.rb);
// this only marks the element ready — which is what the stylesheet reads to hide the quotes that
// are not current and to show the dots — and moves the marker. A reader whose JavaScript never runs
// keeps all six quotes stacked and sees no controls for a carousel that is not there.
//
// IT STOPS MOVING WHEN SOMEONE IS READING IT: on pointer hover, on keyboard focus anywhere inside,
// and for the whole session when the reader has asked for reduced motion. WCAG 2.2.2 wants a way to
// pause content that moves by itself for more than five seconds; hovering or tabbing to it is that
// way, and `prefers-reduced-motion` answers it before the first slide for the people most likely to
// need it. Bootstrap pauses on hover only.
const INTERVAL = 5000

WebComponent.register(
  class extends WebComponent {
    // Named to match `extend Hue::Phlex::CustomElement(:review_band)` rather than derived from this
    // filename, which would make it `components-website-review-band-ns`.
    static componentName = 'review-band'

    // Read each time: the in-place editor redraws the band's insides as its quotes are picked.
    get quotes() {
      return [...this.querySelectorAll('[data-quote]')]
    }

    get dots() {
      return [...this.querySelectorAll('button[data-index]')]
    }

    connectedCallback() {
      this.#start()
      // The in-place editor redraws the band's insides, and a second quote makes it a carousel.
      this.observer = new MutationObserver(() => this.#start())
      this.observer.observe(this, { childList: true, subtree: true })
    }

    #start() {
      const carousel = this.quotes.length > 1
      this.toggleAttribute('data-ready', carousel)
      if (!carousel) return this.stop()

      if (!this.querySelector('[data-quote][data-current]')) this.show(0)
      if (this.wired) return this.#resume()

      this.wired = true
      this.index = 0
      this.locked = false
      this.addEventListener('click', ({ target }) => {
        const dot = target.closest('button[data-index]')
        if (!dot) return

        // Picking a quote is asking for that quote, not for the next one in five seconds.
        this.locked = true
        this.stop()
        this.show(Number(dot.dataset.index))
      })

      if (this.#still) return

      this.addEventListener('pointerenter', () => this.stop())
      this.addEventListener('pointerleave', () => this.start())
      this.addEventListener('focusin', () => this.stop())
      this.addEventListener('focusout', () => this.start())
      this.start()
    }

    get #still() {
      return globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches
    }

    // Back to two quotes from one, which stopped it, unless someone is reading.
    #resume() {
      if (this.timer || this.#still || this.matches(':hover, :focus-within')) return

      this.start()
    }

    disconnectedCallback() {
      this.observer.disconnect()
      this.stop()
    }

    show(index) {
      this.index = (index + this.quotes.length) % this.quotes.length
      this.quotes.forEach((quote, i) => quote.toggleAttribute('data-current', i === this.index))
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)))
    }

    start() {
      if (this.locked) return

      this.stop()
      this.timer = setInterval(() => this.show(this.index + 1), INTERVAL)
    }

    stop() {
      clearInterval(this.timer)
      this.timer = undefined
    }
  }
)
